export const getAllChildDocumentIdsByFolderId = (treeData, folderId) => {
    if (!treeData || !folderId) return [];
  
    const documentIds = [];
    
    const findAndCollect = (nodes) => {
      for (let node of nodes) {
        if (node.key === folderId && node.type === "folder") {
          collectDocs(node);
          return true; // Stop after finding the folder
        }
        if (node.children) {
          if (findAndCollect(node.children)) return true;
        }
      }
      return false;
    };
  
    const collectDocs = (node) => {
      if (!node) return;
  
      if (node.type === "document" && node.key) {
        documentIds.push(node.key);
      }
  
      if (Array.isArray(node.children)) {
        for (const child of node.children) {
          collectDocs(child);
        }
      }
    };
  
    findAndCollect(treeData);
    return documentIds;
  };